// Reports.js
import React, { useState, useEffect } from "react"
import { Box, makeStyles, Typography, Toolbar, Paper, Grid, Link } from "@material-ui/core"
// @ts-ignore
import { useParams, useHistory } from "react-router-dom"
import useStore from "../utils/store"
import consts from "../utils/consts.json"
import CustomBreadcrumbs from "../components/ui-components/custom-breadcrumbs"
import CustomModal from "../components/ui-components/custom-modal"
import CustomTabs from "../components/ui-components/custom-tabs"
import CustomInputSelectSearchable from "../components/form-components/custom-input-select-searchable"
import FindingsAndRecommendations from "../components/app-components/finding-and-recommendations"
import AskAI from "../components/app-components/ask-ai"
import ArchitectureDiagram from "../components/app-components/architecture-diagram"
import FormalMapping from "../components/app-components/formal-mapping"
import Documents from "../components/app-components/documents"
import AuditLog from "../components/app-components/audit-log"
import Simulator from "../components/app-components/simulator"
import FormalSpecification from "../components/app-components/formal-specification"
import Disclaimer from "../components/app-components/disclaimer"
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import WarningIcon from '@material-ui/icons/Warning';
import InfoIcon from '@material-ui/icons/Info';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/background1.jpg)",
    backgroundSize: "cover",
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up("sm")]: {
      padding: theme.spacing(4, 3),
    },
  },
  breadcrumbContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  breadcrumbLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap",
  },
  reviewSelect: {
    minWidth: 240,
    maxWidth: 420,
  },
  disclaimerLink: {
    color: theme.palette.info.main,
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem"
  },
  title: {
    color: theme.palette.primary.contrastText,
    marginBottom: theme.spacing(3),
    fontWeight: 500,
  },
  subtitle: {
    color: theme.palette.primary.contrastText,
    opacity: 0.8,
    marginBottom: theme.spacing(4),
  },
  statsContainer: {
    marginBottom: theme.spacing(3),
  },
  findingCard: {
    padding: theme.spacing(2),
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    borderRadius: theme.spacing(0.5),
    '& .MuiTypography-root': {
      marginLeft: theme.spacing(2),
    },
  },
  criticalCard: {
    backgroundColor: "#ffdddd",
    borderLeft: `${theme.spacing(1)}px solid ${theme.palette.error.main}`,
  },
  highCard: {
    backgroundColor: "#fff2dd",
    borderLeft: `${theme.spacing(1)}px solid ${theme.palette.warning.main}`,
  },
  mediumCard: {
    backgroundColor: "#e6f0ff",
    borderLeft: `${theme.spacing(1)}px solid ${theme.palette.info.main}`,
  },
  lowCard: {
    backgroundColor: "#eeeeee",
    borderLeft: `${theme.spacing(1)}px solid #757575`,
  },
  informationalCard: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    borderLeft: `${theme.spacing(1)}px solid ${theme.palette.primary.light}`,
  },
  infoBox: {
    color: theme.palette.primary.contrastText,
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing(4),
    marginBottom: theme.spacing(2),
  },
  infoValue: {
    fontWeight: 500,
    fontSize: "1.1rem",
    marginRight: theme.spacing(1),
  },
  infoLabel: {
    opacity: 0.7,
    fontSize: "0.9rem",
  },
  findingValue: {
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: 1,
  },
  findingLabel: {
    fontSize: "0.9rem",
    fontWeight: 500,
  },
  criticalValue: {
    color: theme.palette.error.dark,
  },
  highValue: {
    color: theme.palette.warning.dark,
  },
  mediumValue: {
    color: theme.palette.info.main,
  },
  lowValue: {
    color: "#424242",
  },
  lowCardText: {
    color: "#424242",
  },
  informationalValue: {
    color: "#fff",
  },
  informationalLabel: {
    color: "#fff",
  },
  iconCritical: {
    color: theme.palette.error.main,
    fontSize: "2rem",
  },
  iconHigh: {
    color: theme.palette.warning.main,
    fontSize: "2rem",
  },
  iconInformational: {
    color: "#fff",
    fontSize: "2rem",
  },
  iconLow: {
    color: "#757575",
    fontSize: "2rem",
  },
  iconMedium: {
    color: theme.palette.info.main,
    fontSize: "2rem",
  },
  iconLow: {
    color: theme.palette.primary.light,
    fontSize: "2rem",
  },
  tabContainer: {
    width: "100%",
    backgroundColor: "#f5f5f5",
    paddingTop: theme.spacing(4),
  },
  tabContent: {
    width: "100%",
    height: "100%",
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    backgroundColor: "#fff",
  },
  infoContainer: {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
  },
}))

const Reports = () => {
  const classes = useStyles()
  const history = useHistory()
  const [activeTab, setActiveTab] = useState(0)
  const [showDisclaimerModal, setShowDisclaimerModal] = useState(false)
  const fetchOneReview = useStore((state) => state.fetchOneReview)
  const oneReview = useStore((state) => state.oneReview)
  const fetchMyReviews = useStore((state) => state.fetchMyReviews)
  const myReviews = useStore((state) => state.myReviews)
  const isAdmin = useStore((state) => state.isAdmin)
  const checkIsAdmin = useStore((state) => state.checkIsAdmin)
  const { reviewId } = useParams()

  useEffect(() => {
    if (reviewId) {
      fetchOneReview(reviewId)
    }
    // eslint-disable-next-line
  }, [reviewId])

  useEffect(() => {
    if (!myReviews || myReviews.length === 0) {
      fetchMyReviews()
    }
    // Only check admin status once per session — the value is cached in store.
    if (isAdmin === null) {
      checkIsAdmin()
    }
    // eslint-disable-next-line
  }, [])

  const reviewOptions = (myReviews || []).map((r) => ({
    value: r._id,
    label: r.name || "Untitled Review",
  }))

  // Ensure the currently-open review is selectable even if `myReviews` has
  // not loaded yet, or if it does not include this review.
  if (
    oneReview &&
    oneReview._id &&
    !reviewOptions.some((o) => o.value === oneReview._id)
  ) {
    reviewOptions.unshift({
      value: oneReview._id,
      label: oneReview.name || "Untitled Review",
    })
  }

  const handleReviewChange = (newReviewId) => {
    if (newReviewId && newReviewId !== reviewId) {
      history.push(`${consts.ROUTES.REPORTS}/${newReviewId}`)
    }
  }

  const handleDisclaimerClick = () => {
    setShowDisclaimerModal(true)
  }

  const handleCloseModal = () => {
    setShowDisclaimerModal(false)
  }

  // Get compiler version (show only v0.8.11 from "v0.8.11+commit.d7f03943")
  const compilerVersionRaw = oneReview?.compilerVersion || ""
  const compilerVersion = compilerVersionRaw.split("+")[0] || ""

  // Get number of files
  const files = oneReview?.files || []
  const numberOfFiles = files.length

  // Get number of lines (sum of all file contents)
  const numberOfLines = files.reduce((acc, file) => {
    if (file && typeof file.content === "string") {
      return acc + file.content.split(/\r\n|\r|\n/).length
    }
    return acc
  }, 0)

  // Calculate findings counts by severity (case-insensitive to match the
  // findings list, which lowercases severity before comparing).
  const reports = oneReview?.reports || []
  const normalizedSeverity = (report) =>
    (report?.severity || "").toString().trim().toLowerCase()
  const criticalFindings = reports.filter((report) => normalizedSeverity(report) === "critical").length
  const highFindings = reports.filter((report) => normalizedSeverity(report) === "high").length
  const mediumFindings = reports.filter((report) => normalizedSeverity(report) === "medium").length
  const lowFindings = reports.filter((report) => normalizedSeverity(report) === "low").length
  const informationalFindings = reports.filter((report) => normalizedSeverity(report) === "informational").length

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }

  const tabs = [
    {
      id: "findings-and-recommendations",
      label: "Findings and Recommendations",
      component: <FindingsAndRecommendations />,
    },
    {
      id: "ai-formal-specifications",
      label: "AI Formal Requirments",
      component: <FormalSpecification />,
    },
    {
      id: "ask-ai",
      label: "Ask AI",
      component: <AskAI />,
    },
    {
      id: "formal-mapping",
      label: "Formal Mapping",
      component: <FormalMapping />,
    },
    {
      id: "simulator",
      label: "Simulator",
      component: <Simulator />,
    },
    {
      id: "architecture-diagram",
      label: "Architecture Diagram",
      component: <ArchitectureDiagram />,
    },
    {
      id: "documents",
      label: "Documents",
      component: <Documents />,
    },
    ...(isAdmin
      ? [
          {
            id: "audit-log",
            label: "Audit Log",
            component: <AuditLog />,
          },
        ]
      : []),
  ]

  const breadcrumbLinks = [
    { label: "My Reviews", href: "/v2/my-reviews" },
  ]

  return (
    <Box>
      <Toolbar style={{ backgroundColor: "#f5f5f5" }}>
        <Box pt={2} pb={2} className={classes.breadcrumbContainer}>
          <Box className={classes.breadcrumbLeft}>
            <CustomBreadcrumbs links={breadcrumbLinks} />
            <Typography color="textSecondary">/</Typography>
            <CustomInputSelectSearchable
              value={reviewId || ""}
              onChange={handleReviewChange}
              options={reviewOptions}
              placeholder="Select a review"
              searchPlaceholder="Search reviews..."
              className={classes.reviewSelect}
            />
          </Box>

          <Link
            className={classes.disclaimerLink}
            onClick={handleDisclaimerClick}
          >
            Disclaimer
          </Link>
        </Box>
      </Toolbar>

      <Box className={classes.root}>
        
        <Typography variant="h4" className={classes.title}>
          Test Results
        </Typography>
        
        <Box className={classes.infoContainer}>
          <Box className={classes.infoBox}>
            <Typography className={classes.infoValue}>
              {compilerVersion || "8.3.2"} 
            </Typography>
            <Typography className={classes.infoLabel}>
              Solidity Compiler
            </Typography>
          </Box>
          
          <Box className={classes.infoBox}>
            <Typography className={classes.infoValue}>
              {numberOfFiles} 
            </Typography>
            <Typography className={classes.infoLabel}>
              Files
            </Typography>
          </Box>
          
          <Box className={classes.infoBox}>
            <Typography className={classes.infoValue}>
              {numberOfLines.toLocaleString()} 
            </Typography>
            <Typography className={classes.infoLabel}>
              Lines
            </Typography>
          </Box>
        </Box>
        
        <Grid container spacing={3} className={classes.statsContainer}>
          <Grid item xs={12} sm={6} md={2}>
            <Paper className={`${classes.findingCard} ${classes.criticalCard}`}>
              <ErrorOutlineIcon className={classes.iconCritical} />
              <Box>
                <Typography variant="h3" className={`${classes.findingValue} ${classes.criticalValue}`}>
                  {criticalFindings}
                </Typography>
                <Typography className={classes.findingLabel}>
                  Critical Findings
                </Typography>
              </Box>
            </Paper>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Paper className={`${classes.findingCard} ${classes.highCard}`}>
              <WarningIcon className={classes.iconHigh} />
              <Box>
                <Typography variant="h3" className={`${classes.findingValue} ${classes.highValue}`}>
                  {highFindings}
                </Typography>
                <Typography className={classes.findingLabel}>
                  High Findings
                </Typography>
              </Box>
            </Paper>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Paper className={`${classes.findingCard} ${classes.mediumCard}`}>
              <InfoIcon className={classes.iconMedium} />
              <Box>
                <Typography variant="h3" className={`${classes.findingValue} ${classes.mediumValue}`}>
                  {mediumFindings}
                </Typography>
                <Typography className={classes.findingLabel}>
                  Medium Finding
                </Typography>
              </Box>
            </Paper>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Paper className={`${classes.findingCard} ${classes.lowCard}`}>
              <InfoOutlinedIcon className={classes.iconLow} />
              <Box>
                <Typography variant="h3" className={`${classes.findingValue} ${classes.lowValue}`}>
                  {lowFindings}
                </Typography>
                <Typography className={`${classes.findingLabel} ${classes.lowCardText}`}>
                  Low Findings
                </Typography>
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={6} md={2}>
            <Paper className={`${classes.findingCard} ${classes.informationalCard}`}>
              <HelpOutlineIcon className={classes.iconInformational} />
              <Box>
                <Typography variant="h3" className={`${classes.findingValue} ${classes.informationalValue}`}>
                  {informationalFindings}
                </Typography>
                <Typography className={`${classes.findingLabel} ${classes.informationalLabel}`}>
                  Informational
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <Box className={classes.tabContainer}>
        <Toolbar style={{ backgroundColor: "#f5f5f5" }}>
          <CustomTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </Toolbar>
        <Box className={classes.tabContent}>
          {(tabs[activeTab] || tabs[0]).component}
        </Box>
      </Box>

      <CustomModal
        showModal={showDisclaimerModal}
        size="medium"
        title="Disclaimer"
        onCloseModal={handleCloseModal}
        cancelBtnText="Close"
      >
        <Disclaimer />
      </CustomModal>
    </Box>
  )
}

export default Reports
